import { createContext, PropsWithChildren, useState } from 'react';

type BulkShareContextValue = {
  multiSelectModeEnabled: boolean;
  setMultiSelectModeEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  selectedUserMaterial: string[];
  setSelectedUserMaterial: React.Dispatch<React.SetStateAction<string[]>>;
  selectedMedialinks: string[];
  setSelectedMedialinks: React.Dispatch<React.SetStateAction<string[]>>;
};

const BulkShareContext = createContext<BulkShareContextValue>({
  multiSelectModeEnabled: false,
  setMultiSelectModeEnabled: () => {},
  selectedUserMaterial: [],
  setSelectedUserMaterial: () => {},
  selectedMedialinks: [],
  setSelectedMedialinks: () => {},
});

export default BulkShareContext;

export function BulkShareContextProvider({ children }: PropsWithChildren) {
  const [multiSelectModeEnabled, setMultiSelectModeEnabled] = useState(false);
  const [selectedUserMaterial, setSelectedUserMaterial] = useState<string[]>([]);
  const [selectedMedialinks, setSelectedMedialinks] = useState<string[]>([]);

  return (
    <BulkShareContext.Provider
      value={{
        multiSelectModeEnabled,
        setMultiSelectModeEnabled,
        selectedUserMaterial,
        setSelectedUserMaterial,
        selectedMedialinks,
        setSelectedMedialinks,
      }}
    >
      {children}
    </BulkShareContext.Provider>
  );
}
